// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar__avatar--3TmQW","small":"Avatar__small--25Dca","medium":"Avatar__medium--2iwjn","large":"Avatar__large--jbvvS"};